import HTTP from '@/api/HTTP';
import transformerEcranNumeriqueByBailleur
  from '@/services/gabed/materiel/filter/ecranNumeriqueByBailleurServerTableDataTransformer';

const URL_BASE = 'patri/EcranNumeriqueByBailleur/';

export default async function getAll(param) {
  const inputServer = transformerEcranNumeriqueByBailleur(param);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}
